// src/JoinAuction.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';

const JoinAuction = () => {
  const [auctionCode, setAuctionCode] = useState('');
  const [auctionItems, setAuctionItems] = useState([]);
  const navigate = useNavigate();

  const handleJoinAuction = async () => {
    const { data, error } = await supabase
      .from('auction_items')
      .select('*')
      .eq('auction_code', auctionCode);

    if (error || data.length === 0) {
      alert('Invalid auction code or no items in this auction.');
    } else {
      setAuctionItems(data);
    }
  };

  return (
    <div>
      <h1>Join an Auction</h1>
      <input
        type="text"
        placeholder="Enter Auction Code"
        value={auctionCode}
        onChange={(e) => setAuctionCode(e.target.value)}
      />
      <button onClick={handleJoinAuction}>Join Auction</button>

      {auctionItems.length > 0 && (
        <div>
          <h2>Auction Items</h2>
          {auctionItems.map((item) => (
            <div key={item.id}>
              <p>Item: {item.item_name}</p>
              <p>Description: {item.description}</p>
              <p>Starting Bid: ${item.starting_bid}</p>
              <button onClick={() => navigate(`/place-bid/${auctionCode}/${item.id}`)}>
                Place Bid
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default JoinAuction;
